<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell *ngIf="!isLoading && customer">
    <app-page-detail-hero
        eyebrow="Customer Profile"
        [title]="customer.name"
        [subtitle]="customer.emailAddress || customer.phoneNumber || 'No contact details captured'"
        [preferMedia]="true">
        <div media class="customer-hero-media">
            <div class="customer-avatar customer-avatar-lg">
                <img [src]="customer.imageUrl || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'"
                    [alt]="customer.name || 'Customer profile'" />
            </div>
            <div class="customer-hero-media-actions">
                <input #customerImageInput type="file" accept="image/*" hidden (change)="uploadProfileImage($event)" />
                <p-button type="button" icon="pi pi-camera" severity="secondary" size="small"
                    [outlined]="true" [loading]="isProfileImageUploadInProgress" [disabled]="isProfileImageUploadInProgress"
                    (onClick)="customerImageInput.click()"></p-button>
                <small *ngIf="isProfileImageUploadInProgress">Uploading {{ profileImageUploadProgress }}%</small>
            </div>
        </div>
        <div tags>
            <p-tag [value]="'ID ' + customer.id" severity="info"></p-tag>
            <p-tag *ngIf="customer.company?.name" [value]="customer.company.name" severity="success"></p-tag>
        </div>
        <div actions>
            <p-button icon="pi pi-envelope" label="Email" severity="secondary" [outlined]="true"
                [disabled]="!customer.emailAddress || customer.emailAddress.includes('@abcxyz.com')"
                (click)="sendEmail(customer.emailAddress)"></p-button>
            <p-button icon="pi pi-phone" label="Call" severity="secondary" [outlined]="true"
                [disabled]="!customer.phoneNumber"
                (click)="makePhoneCall(customer.phoneNumber)"></p-button>
            <p-button icon="pi pi-pencil" label="Edit Profile" (click)="openEditProfile()"></p-button>
        </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

    <app-page-data-panel title="Profile Workspace" subtitle="Customer details, access roles, and personal payment methods.">
        <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange({ index: $event })">
            <p-tablist>
                <p-tab [value]="0"><span class="tab-label"><i class="pi pi-id-card"></i> Details</span></p-tab>
                <p-tab [value]="1"><span class="tab-label"><i class="pi pi-shield"></i> Roles</span></p-tab>
                <p-tab [value]="2"><span class="tab-label"><i class="pi pi-credit-card"></i> Payment Methods</span></p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <div class="profile-grid">
                        <section class="info-panel">
                            <div class="panel-title">
                                <div class="customer-avatar customer-avatar-md">
                                    <img [src]="customer.imageUrl || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'"
                                        [alt]="customer.name || 'Customer profile'" />
                                </div>
                                <div>
                                    <h3>{{ customer.name }}</h3>
                                    <p>Customer contact</p>
                                </div>
                            </div>
                            <div class="detail-list">
                                <div><span>ID</span><strong>{{ customer.id }}</strong></div>
                                <div><span>Email</span><strong>{{ customer.emailAddress || 'N/A' }}</strong></div>
                                <div><span>Phone</span><strong>{{ customer.phoneNumber || 'N/A' }}</strong></div>
                                <div><span>Address</span><strong>{{ customer.address || 'N/A' }}</strong></div>
                            </div>
                        </section>

                        <section class="info-panel">
                            <div class="panel-title">
                                <p-image [routerLink]="['/company', linkedCompany?.id]"
                                    [src]="linkedCompany?.logo || 'https://cdn-icons-png.flaticon.com/512/4299/4299051.png'"
                                    height="54" imageClass="border-round"></p-image>
                                <div>
                                    <h3>{{ linkedCompany?.name || 'No company linked' }}</h3>
                                    <p>Organization context</p>
                                </div>
                            </div>
                            <div class="detail-list">
                                <div><span>Email</span><strong>{{ linkedCompany?.emailAddress || 'N/A' }}</strong></div>
                                <div><span>Phone</span><strong>{{ linkedCompany?.phoneNumber || 'N/A' }}</strong></div>
                                <div><span>CR Number</span><strong>{{ linkedCompany?.crNumber || 'N/A' }}</strong></div>
                                <div>
                                    <span>Address</span>
                                    <a *ngIf="linkedCompany?.location" target="_blank"
                                        href="https://maps.google.com?q={{ linkedCompany?.location?.latitude }},{{ linkedCompany?.location?.longitude }}">
                                        {{ linkedCompany?.address || 'Open map' }}
                                    </a>
                                    <strong *ngIf="!linkedCompany?.location">{{ linkedCompany?.address || 'N/A' }}</strong>
                                </div>
                            </div>
                        </section>
                    </div>
                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <p-table [value]="roles" dataKey="roleId" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '56rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Role ID</th>
                                <th>Role Name</th>
                                <th>Description</th>
                                <th>Permissions</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-role>
                            <tr>
                                <td>{{ role.roleId }}</td>
                                <td><strong>{{ role.roleName }}</strong></td>
                                <td>{{ role.description || 'N/A' }}</td>
                                <td>
                                    <div class="chip-list">
                                        <p-chip *ngFor="let permission of role.permissions" [label]="permission.permissionName"></p-chip>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <button pButton type="button" icon="pi pi-pencil" pTooltip="Edit"
                                        (click)="editRole(role)" class="p-button-rounded p-button-text p-button-secondary"></button>
                                    <button pButton type="button" icon="pi pi-trash" pTooltip="Delete"
                                        (click)="deleteRole(role)" class="p-button-rounded p-button-text p-button-danger"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr><td colspan="5" class="text-center p-4">No roles assigned.</td></tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>
                <p-tabpanel [value]="2">
                    <div class="table-toolbar">
                        <p-button type="button" label="New Payment Method" icon="pi pi-plus"
                            (click)="createNewPaymentMethod()"></p-button>
                    </div>
                    <p-table [value]="personalPaymentMethods" dataKey="id" styleClass="p-datatable-sm"
                        [tableStyle]="{ 'min-width': '54rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>ID</th>
                                <th>Payment Type</th>
                                <th>Token</th>
                                <th>Default</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-paymentMethod>
                            <tr>
                                <td>{{ paymentMethod.personalPaymentId }}</td>
                                <td><strong>{{ paymentMethod.paymentCardName || paymentMethod.paymentMethod?.name || 'Payment method' }}</strong></td>
                                <td>{{ paymentMethod.paymentCardToken || paymentMethod.last4digits || 'N/A' }}</td>
                                <td>
                                    <p-checkbox [(ngModel)]="paymentMethod.isDefault" [binary]="true" [disabled]="true"></p-checkbox>
                                </td>
                                <td class="text-right">
                                    <button pButton type="button" icon="pi pi-pencil" pTooltip="Edit"
                                        (click)="editPaymentMethod(paymentMethod)" class="p-button-rounded p-button-text p-button-secondary"></button>
                                    <button pButton type="button" icon="pi pi-trash" pTooltip="Delete"
                                        (click)="deletePaymentMethod(paymentMethod)" class="p-button-rounded p-button-text p-button-danger"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr><td colspan="5" class="text-center p-4">No payment methods found.</td></tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
</app-page-shell>

<app-customer-form [displayModal]="showCustomerForm" [dialogHeader]="customerFormHeader"
    [submitButtonLabel]="customerFormSubmitLabel" [customer]="customer" [company]="customer.company"
    (modalClosed)="onCustomerFormClosed()">
</app-customer-form>
